module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAABNUlEQVRIS+2VLU8DQRCGn1eV8OEQaGT/AIYEBarsnGrgF/AhkaBBIvn4BZCq26OqjgSJrkWCwAEJVUMKByH0erkmECDp2pl5dt93ZndFycqyrOHuO8ACMJmnPgDXkg5DCO1h5RoWSNN0X9IucC+p4+6Pee4MsAzMuvtBkiR7RYxCcJZl5u4p0O71euvNZvMd+spotVrTtVrtDGhISkII8Su8EBxjvATqwLyZ9aUPrBx+A3TNbKkq+EnSRQhhrawHaZqeS1o1s6mqYAeOzWy7DBxjPAK2zGxA+TArxuA3R2OM7u5dSVdlHrv7oqR6occxxgCcAnNlkBFid8CGYoy3wDPQGaG4LHUFmOiDK01A1U3fR/D3wbkyihr1Wc3IJx6DP+z7f1b8qTn+mSudf5wn3/kISdp8AXz66odQ+jeGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lock.png
// module id = eV+J
// module chunks = 3